"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MangoTracker;
async function MangoTracker(config, postId) {
    const TRACKER_BASE_URL = config["TRACKER_BASE_URL"];
    if (!TRACKER_BASE_URL) {
        console.error("TRACKER_BASE_URL not found in config");
        return null;
    }
    const url = `https://${TRACKER_BASE_URL}/TrackView/${postId}`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!(response === null || response === void 0 ? void 0 : response.ok)) {
            console.error(`Failed to send track view: ${response === null || response === void 0 ? void 0 : response.statusText}`);
        }
        if (response) {
            return "ok";
        }
    }
    catch (error) {
        // Network failures here are non-critical (best-effort view tracking) and must not
        // surface as unhandled promise rejections at call sites that don't await/catch this.
        console.error("Error sending track view:", error);
        return null;
    }
}
